import type { RequestDocument, RequestOptions, Variables } from "graphql-request";
import { GraphQLClient } from "graphql-request";

import { newrelic } from "@jti/fe-clients";
import { MagentoGraphQLRequestClientError, validateMagentoErrorCodes } from "@jti/magento-api-v2/clients";

export class MagentoGraphQLRequestClient extends GraphQLClient {
  async request<T = any, V = Variables>(
    document: RequestDocument,
    variables?: V | undefined,
    requestHeaders?: Record<string, string> | undefined
  ): Promise<T>;
  async request<T = any, V extends Record<string, any> = Variables>(options: RequestOptions<V>): Promise<T>;
  async request<T = any>(
    document: unknown,
    variables?: unknown,
    requestHeaders?: Record<string, string> | undefined
  ): Promise<T> {
    try {
      return await super.request(document as RequestDocument, variables as Variables, requestHeaders);
    } catch (error: unknown) {
      const graphQLError = new MagentoGraphQLRequestClientError(error, document as RequestDocument, variables);
      validateMagentoErrorCodes(graphQLError.errorCodes, graphQLError.errorsDetails);
      graphQLError.log();
      newrelic.noticeError(graphQLError);
      throw graphQLError;
    }
  }
}
